import axios from 'axios';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';
import { invoicesActions } from './reducer';
import { withRouter } from 'react-router-dom';
import Modal from '../../commons/Components/Modal';
import React, { useEffect, useState } from 'react';
import { getChipColor } from '../../utils/guideStatus';
import { formatDate, getItemInStorage } from '../../utils/functions';
import Facturama from '../../commons/Components/Facturama';
import Payment from '../../commons/Components/Payment';
import { actionProps, selectState } from '../../utils/reduxActions';
import { invoiceActions } from '../../commons/Components/Facturama/reducer';
import { DataGrid, GridColDef, GridToolbarContainer, GridSelectionModel } from '@mui/x-data-grid';
import { SERVER_URL, APPLICATION_KEY, SECRET_KEY } from '../../utils/constants';

interface Guide {
  id?: string;
  _id?: string;
  serviceName: string;
  destination: string;
  trackingNumber: string;
  createdAt: string;
  actions: any;
  guideUrl: string;
  guideUrl6x4?: string;
  PaymentForm?: string;
  transaction?: {
    _id: string;
  };
}

interface InvoicesProps {
  actions?: any;
  controls?: any;
  history?: any;
  list?: Guide[];
  report?: any;
  invoiceControls?: any;
  profile?: any;
  paymentControls?: any;
}

const CustomToolbar = () => {
  return <GridToolbarContainer></GridToolbarContainer>;
};

const Invoices: React.FC<InvoicesProps> = props => {
  const { profile, actions, list, controls, invoiceControls, paymentControls } = props;
  let [isOpenModalInvoice, setIsOpenModalInvoice] = useState(false);
  let [isOpenModalComplement, setIsOpenModalComplement] = useState(false);
  const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
  const [selectionModel, setSelectionModel] = React.useState<GridSelectionModel>([]);
  
  const openModal = () => {
    setIsOpenModalInvoice(true);
  };
  const createInvoice = (data: any) => {
    actions.fieldsChanged({
      transactionIds: [],
      paymentForm: '',
      guides: [],
      serviceName: [],
    });
    openModal();
  };

  const createPayment = () => {
    setIsOpenModalComplement(true);
  };

  const getInvoiceByFormat = async (format: string, data: any) => {
    const cfdiId = data?.Id || data?.transaction?.invoiceId;
    const fileName = data?.Folio || cfdiId;
    const token = getItemInStorage('token');
    try {
      const response = await axios.get(
        `${SERVER_URL}/invoice/format?format=${format}&id=${cfdiId}`,
        {
          headers: {
            application: APPLICATION_KEY,
            secret: SECRET_KEY,
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.data.data.Content) {
        const byteCharacters = atob(response.data.data.Content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: `application/${format}`,
        });

        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');

        const downloadLink = document.createElement('a');
        downloadLink.href = fileURL;
        downloadLink.download = `FacturaFolio_${fileName}.${format}`;
        downloadLink.click();

        URL.revokeObjectURL(fileURL);
      } else {
        Swal.fire({
          title: 'No se encontró factura',
          text: 'Favor de contactar al administrador',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Ocurrió un error',
        text: 'Por favor, inténtalo de nuevo',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      });
    }
  };

  const handlerCancelInvoice = (data: any) => {
    Swal.fire({
      title: 'Desea cancelar la Factura?',
      text: '¡No podrás revertir esto!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, cancelar!',
      cancelButtonText: 'No, abortar!',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      html: `
        <div class="mb-4">
          <label class="block text-left mb-1">Motivo de cancelación*</label>
          <select id="cancel-reason" class="w-full border border-gray-300 rounded px-3 py-2">
            <option value="">Seleccione un motivo</option>
            <option value="01">01 - Comprobante emitido con errores con relación</option>
            <option value="02">02 - Comprobante emitido con errores sin relación</option>
            <option value="03">03 - No se llevó a cabo la operación</option>
            <option value="04">04 - Operación nominativa relacionada en la factura global</option>
          </select>
        </div>
        <div class="mb-4">
          <label class="block text-left mb-1">UUID de sustitución (opcional)</label>
          <input id="uuid-replacement" class="w-full border border-gray-300 rounded px-3 py-2" placeholder="UUID de la factura que sustituye a la cancelada">
        </div>
      `,
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {
          confirmButton.disabled = true;
          
          document.getElementById('cancel-reason')?.addEventListener('change', (e) => {
            const target = e.target as HTMLSelectElement;
            if (confirmButton) {
              confirmButton.disabled = !target.value;
            }
          });
        }
      },
      preConfirm: async () => {
        const reason = (document.getElementById('cancel-reason') as HTMLSelectElement).value;
        const uuidReplacement = (document.getElementById('uuid-replacement') as HTMLInputElement).value;
        
        if (!reason) {
          Swal.showValidationMessage('Debe seleccionar un motivo de cancelación');
          return false;
        }
        
        const token = getItemInStorage('token');
        return await axios
          .post(
            `${SERVER_URL}/invoice/cancel`,
            { 
              id: data?.Id || data?.transaction?._id,
              reason,
              uuidReplacement: uuidReplacement || undefined
            },
            {
              headers: {
                application: APPLICATION_KEY,
                secret: SECRET_KEY,
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            },
          )
          .then(res => {
            return res.data;
          })
          .catch(error => {
            Swal.showValidationMessage(
              `Error al cancelar la factura: ${error.response.data.message || error.message || 'Error desconocido'}`,
            );
          });
      },
    }).then(result => {
      if (result.isConfirmed && result.value) {
        console.log(result);
        Swal.fire(
          '¡Solicitud extitosa!',
          'La cancelación de la factura ha sido solicitada al SAT. Recuerda que la cancelación puede requerir aceptación del receptor.',
          'success',
        ).then(() => {
          window.location.reload();
        });
      }
    });
  };

  const handlerCancelCheckInvoice = (data: any) => {
    Swal.fire({
      title: '¿Deseas consultar el estatus de la cancelación en el SAT?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No, cancelar!',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        const token = getItemInStorage('token');
        return await axios
          .post(
            `${SERVER_URL}/invoice/cancel`,
            { id: data.provider == 'listo'
              ? data?.Id
              : data?.transaction?._id || data?.Id
            },
            {
              headers: {
                application: APPLICATION_KEY,
                secret: SECRET_KEY,
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            },
          )
          .then(res => {
            return res.data; // Return something to resolve the promise
          })
          .catch(error => {
            Swal.showValidationMessage(
              `Error al cancelar la factura: ${error.message}`,
            );
          });
      },
    }).then(result => {
      if (result.isConfirmed && result.value) {
        if (result.value.data.status == 'done') {
          Swal.fire(
            'La factura ha sido cancelada',
            `Estatus en el SAT: ${result.value.data.message}`,
            'success',
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire(
            'La factura aún no ha sido cancelada',
            `Estatus en el SAT: ${result.value.data.message}`,
            'success',
          ).then(() => {
            window.location.reload();
          });
        }
      }
    });
  };

  useEffect(() => {
    actions.getInvoicesList();
  }, []);

  useEffect(() => {
    if (invoiceControls.success) {
      setIsOpenModalInvoice(false);
      setIsOpenModalComplement(false);
      actions.getInvoicesList();
    }
  }, [invoiceControls.success, actions]);

  useEffect(() => {
    if (paymentControls?.createPaymentRes) {
      setIsOpenModalComplement(false);
      setSelectedRows([]);
      setSelectionModel([]);
      actions.getInvoicesList();
    }
  }, [paymentControls?.createPaymentRes, actions]);

  const columns: GridColDef[] = [
    {
      field: 'Date',
      headerName: 'Fecha de emisión',
      minWidth: 160,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      headerClassName: 'text-lg text-bold',
      valueGetter: (params: any) => params.row.Date,
      valueFormatter: (params: any) => formatDate(params.value),
    },
    {
      field: 'invoice.Folio',
      headerName: 'Folio de factura',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      minWidth: 140,
      headerClassName: 'text-lg text-bold',
      valueGetter: (params: any) => params.row.Folio,
    },
    {
      field: 'trackingNumber',
      headerName: 'No. Rastreo',
      type: 'number',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      minWidth: 130,
      headerClassName: 'text-lg text-bold',
      valueGetter: (params: any) => params?.row?.trackingNumber || 'N/A',
    },
    {
      field: 'invoice.PaymentTerms',
      headerName: 'Forma de pago',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      minWidth: 150,
      headerClassName: 'text-lg text-bold',
      valueGetter: (params: any) => params.row.PaymentTerms || 'N/A',
    },
    {
      field: 'invoice.PaymentMethod',
      headerName: 'Método de pago',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      minWidth: 150,
      headerClassName: 'text-lg text-bold',
      valueGetter: (params: any) =>
        params.row.provider === 'listo'
          ? params.row.PaymentMethod || 'N/A'
          : params.row.PaymentForm || params.row.PaymentMethod || 'N/A',
    },
    {
      field: 'invoice.Total',
      headerName: 'Monto facturado',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      minWidth: 140,
      headerClassName: 'text-lg text-bold',
      valueGetter: (params: any) => params.row.Total ?? 0,
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      flex: 1,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      headerClassName: 'text-lg text-bold',
      sortable: false,
      minWidth: 220,
      renderCell: data => {
        return (
          <div>
            {data.row?.transaction?.invoiced || data.row?.Status == 'active' ? (
              <div className='grid grid-cols-5 grid-flow-col gap-2 grid-flow-row-dense'>
                <Tooltip
                  title={'Cancelar Factura'}
                  arrow
                >
                  <div>
                    <button
                      className={`${
                        !getChipColor(data.row.internalStatus)
                          ? 'bg-primary-inabit-disabled'
                          : 'bg-red-500 hover:bg-red-600'
                      } text-center p-2 text-white hover:text-white w-full h-full flex justify-center items-center rounded-lg`}
                      onClick={() => handlerCancelInvoice(data.row)}
                      disabled={!getChipColor(data.row.internalStatus)}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                        strokeWidth='1.5'
                        stroke='currentColor'
                        className='w-6 h-6'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z'
                        />
                      </svg>
                    </button>
                  </div>
                </Tooltip>
                {(data.row?.payment?.metadata?.certifyResponse?.invoice?.pdf?.url ||
                  (data.row?.payment && data.row.provider !== 'listo')) && (
                  <Tooltip
                    title='Descargar Pago PDF'
                    arrow
                  >
                    <div className='bg-primary-inabit-light-green hover:bg-primary-inabit-light-green rounded-lg h-12 shadow flex justify-center items-center'>
                      {data.row?.payment?.metadata?.certifyResponse?.invoice?.pdf?.url ? (
                        <a
                          className='text-center p-4 text-white hover:text-white'
                          href={data.row.payment.metadata.certifyResponse.invoice.pdf.url}
                          target='_blank'
                          rel='noreferrer'
                          download={
                            data.row.payment.metadata.certifyResponse.invoice.pdf.filename || `PagoFolio_${data.row?.Folio || data.row?.Id}.pdf`
                          }
                        >
                          <svg
                            width='30px'
                            height='30px'
                            viewBox='0 0 24 24'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            stroke='#FFFFFF'
                          >
                            <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                            <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round'></g>
                            <g id='SVGRepo_iconCarrier'>
                              <path
                                d='M4 4C4 3.44772 4.44772 3 5 3H14H14.5858C14.851 3 15.1054 3.10536 15.2929 3.29289L19.7071 7.70711C19.8946 7.89464 20 8.149 20 8.41421V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V4Z'
                                stroke='#FFFFFF'
                                strokeWidth='2'
                                strokeLinecap='round'
                              ></path>
                              <path
                                d='M20 8H15V3'
                                stroke='#FFFFFF'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                              <path
                                d='M11.5 13H11V17H11.5C12.6046 17 13.5 16.1046 13.5 15C13.5 13.8954 12.6046 13 11.5 13Z'
                                stroke='#FFFFFF'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                              <path
                                d='M15.5 17V13L17.5 13'
                                stroke='#FFFFFF'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                              <path
                                d='M16 15H17'
                                stroke='#FFFFFF'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                              <path
                                d='M7 17L7 15.5M7 15.5L7 13L7.75 13C8.44036 13 9 13.5596 9 14.25V14.25C9 14.9404 8.44036 15.5 7.75 15.5H7Z'
                                stroke='#FFFFFF'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                            </g>
                          </svg>
                        </a>
                      ) : (
                        <button
                          className='text-center p-4 text-white hover:text-white'
                          onClick={() => {
                            getInvoiceByFormat('pdf', data.row.payment);
                          }}
                        >
                          <svg
                            width='30px'
                            height='30px'
                            viewBox='0 0 24 24'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            stroke='#FFFFFF'
                          >
                            <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                            <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round'></g>
                            <g id='SVGRepo_iconCarrier'>
                              <path
                                d='M4 4C4 3.44772 4.44772 3 5 3H14H14.5858C14.851 3 15.1054 3.10536 15.2929 3.29289L19.7071 7.70711C19.8946 7.89464 20 8.149 20 8.41421V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V4Z'
                                stroke='#FFFFFF'
                                strokeWidth='2'
                                strokeLinecap='round'
                              ></path>
                              <path
                                d='M20 8H15V3'
                                stroke='#FFFFFF'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                              <path
                                d='M11.5 13H11V17H11.5C12.6046 17 13.5 16.1046 13.5 15C13.5 13.8954 12.6046 13 11.5 13Z'
                                stroke='#FFFFFF'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                              <path
                                d='M15.5 17V13L17.5 13'
                                stroke='#FFFFFF'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                              <path
                                d='M16 15H17'
                                stroke='#FFFFFF'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                              <path
                                d='M7 17L7 15.5M7 15.5L7 13L7.75 13C8.44036 13 9 13.5596 9 14.25V14.25C9 14.9404 8.44036 15.5 7.75 15.5H7Z'
                                stroke='#FFFFFF'
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              ></path>
                            </g>
                          </svg>
                        </button>
                      )}
                    </div>
                  </Tooltip>
                )}
                {(data.row?.payment?.metadata?.certifyResponse?.invoice?.xml?.url ||
                  (data.row?.payment && data.row.provider !== 'listo')) && (
                  <Tooltip
                    title='Descargar Pago XML'
                    arrow
                  >
                    <div className='bg-primary-inabit-light-green hover:bg-primary-inabit-light-green rounded-lg h-12 shadow flex justify-center items-center'>
                      {data.row?.payment?.metadata?.certifyResponse?.invoice?.xml?.url ? (
                        <a
                          className='text-center p-4 text-white hover:text-white'
                          href={data.row.payment.metadata.certifyResponse.invoice.xml.url}
                          target='_blank'
                          rel='noreferrer'
                          download={
                            data.row.payment.metadata.certifyResponse.invoice.xml.filename || `PagoFolio_${data.row?.Folio || data.row?.Id}.xml`
                          }
                        >
                          <svg
                            height='30px'
                            width='30px'
                            version='1.1'
                            id='_x32_'
                            viewBox='0 0 512 512'
                            fill='#FFFFFF'
                          >
                            <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                            <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round'></g>
                            <g id='SVGRepo_iconCarrier'>
                              <g>
                                <path d='M378.406,0H208.29h-13.176l-9.314,9.314L57.013,138.102l-9.314,9.314v13.176v265.514 c0,47.36,38.528,85.895,85.895,85.895h244.812c47.368,0,85.895-38.535,85.895-85.895V85.896C464.301,38.528,425.773,0,378.406,0z M432.49,426.105c0,29.877-24.214,54.091-54.084,54.091H133.594c-29.877,0-54.091-24.214-54.091-54.091V160.591h83.717 c24.884,0,45.07-20.178,45.07-45.07V31.804h170.115c29.87,0,54.084,24.214,54.084,54.092V426.105z'></path>
                                <path d='M178.002,297.743l21.051-30.701c1.361-2.032,2.032-4.07,2.032-6.109c0-5.027-3.938-8.965-9.37-8.965 c-3.394,0-6.11,1.494-8.281,4.754l-16.575,24.452h-0.265l-16.576-24.452c-2.172-3.26-4.888-4.754-8.281-4.754 c-5.432,0-9.37,3.938-9.37,8.965c0,2.039,0.67,4.077,2.031,6.109l20.919,30.701l-22.546,33.138 c-1.355,2.039-2.039,4.077-2.039,6.116c0,5.027,3.938,8.965,9.371,8.965c3.393,0,6.116-1.494,8.288-4.755l18.203-26.896h0.265 l18.203,26.896c2.171,3.261,4.894,4.755,8.287,4.755c5.432,0,9.37-3.938,9.37-8.965c0-2.039-0.677-4.078-2.039-6.116 L178.002,297.743z'></path>
                                <path d='M291.016,251.968c-5.977,0-9.238,3.261-12.226,10.326l-19.284,44.547h-0.545l-19.697-44.547 c-3.121-7.066-6.382-10.326-12.358-10.326c-6.654,0-11.004,4.622-11.004,11.954v72.398c0,6.109,3.806,9.643,9.244,9.643 c5.153,0,8.958-3.534,8.958-9.643v-44.554h0.678l14.397,33.138c2.856,6.522,5.167,8.428,9.782,8.428 c4.615,0,6.927-1.906,9.782-8.428L283,291.766h0.684v44.554c0,6.109,3.666,9.643,9.098,9.643c5.432,0,9.098-3.534,9.098-9.643 v-72.398C301.88,256.59,297.67,251.968,291.016,251.968z'></path>
                                <path d='M373.211,327.355h-32.873c-0.544,0-0.824-0.272-0.824-0.816V262.56c0-6.381-4.203-10.592-9.915-10.592 c-5.837,0-10.04,4.21-10.04,10.592v72.532c0,5.976,3.938,10.054,10.04,10.054h43.611c6.102,0,10.04-3.666,10.04-8.965 C383.251,331.02,379.313,327.355,373.211,327.355z'></path>
                              </g>
                            </g>
                          </svg>
                        </a>
                      ) : (
                        <button
                          className='text-center p-4 text-white hover:text-white'
                          onClick={() => {
                            getInvoiceByFormat('xml', data.row.payment);
                          }}
                        >
                          <svg
                            height='30px'
                            width='30px'
                            version='1.1'
                            id='_x32_'
                            viewBox='0 0 512 512'
                            fill='#FFFFFF'
                          >
                            <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                            <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round'></g>
                            <g id='SVGRepo_iconCarrier'>
                              <g>
                                <path d='M378.406,0H208.29h-13.176l-9.314,9.314L57.013,138.102l-9.314,9.314v13.176v265.514 c0,47.36,38.528,85.895,85.895,85.895h244.812c47.368,0,85.895-38.535,85.895-85.895V85.896C464.301,38.528,425.773,0,378.406,0z M432.49,426.105c0,29.877-24.214,54.091-54.084,54.091H133.594c-29.877,0-54.091-24.214-54.091-54.091V160.591h83.717 c24.884,0,45.07-20.178,45.07-45.07V31.804h170.115c29.87,0,54.084,24.214,54.084,54.092V426.105z'></path>
                                <path d='M178.002,297.743l21.051-30.701c1.361-2.032,2.032-4.07,2.032-6.109c0-5.027-3.938-8.965-9.37-8.965 c-3.394,0-6.11,1.494-8.281,4.754l-16.575,24.452h-0.265l-16.576-24.452c-2.172-3.26-4.888-4.754-8.281-4.754 c-5.432,0-9.37,3.938-9.37,8.965c0,2.039,0.67,4.077,2.031,6.109l20.919,30.701l-22.546,33.138 c-1.355,2.039-2.039,4.077-2.039,6.116c0,5.027,3.938,8.965,9.371,8.965c3.393,0,6.116-1.494,8.288-4.755l18.203-26.896h0.265 l18.203,26.896c2.171,3.261,4.894,4.755,8.287,4.755c5.432,0,9.37-3.938,9.37-8.965c0-2.039-0.677-4.078-2.039-6.116 L178.002,297.743z'></path>
                                <path d='M291.016,251.968c-5.977,0-9.238,3.261-12.226,10.326l-19.284,44.547h-0.545l-19.697-44.547 c-3.121-7.066-6.382-10.326-12.358-10.326c-6.654,0-11.004,4.622-11.004,11.954v72.398c0,6.109,3.806,9.643,9.244,9.643 c5.153,0,8.958-3.534,8.958-9.643v-44.554h0.678l14.397,33.138c2.856,6.522,5.167,8.428,9.782,8.428 c4.615,0,6.927-1.906,9.782-8.428L283,291.766h0.684v44.554c0,6.109,3.666,9.643,9.098,9.643c5.432,0,9.098-3.534,9.098-9.643 v-72.398C301.88,256.59,297.67,251.968,291.016,251.968z'></path>
                                <path d='M373.211,327.355h-32.873c-0.544,0-0.824-0.272-0.824-0.816V262.56c0-6.381-4.203-10.592-9.915-10.592 c-5.837,0-10.04,4.21-10.04,10.592v72.532c0,5.976,3.938,10.054,10.04,10.054h43.611c6.102,0,10.04-3.666,10.04-8.965 C383.251,331.02,379.313,327.355,373.211,327.355z'></path>
                              </g>
                            </g>
                          </svg>
                        </button>
                      )}
                    </div>
                  </Tooltip>
                )}
                <Tooltip
                  title='Descargar Factura PDF'
                  arrow
                >
                  <div className='bg-primary-inabit-blue hover:bg-primary-inabit-blue-hover rounded-lg h-12 shadow flex justify-center items-center'>
                    <button
                      className='text-center p-4 text-white hover:text-white'
                      onClick={() => {
                        getInvoiceByFormat('pdf', data.row);
                      }}
                      disabled={!getChipColor(data.row.internalStatus)}
                    >
                      <svg
                        width='30px'
                        height='30px'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        stroke='#FFFFFF'
                      >
                        <g
                          id='SVGRepo_bgCarrier'
                          strokeWidth='0'
                        ></g>
                        <g
                          id='SVGRepo_tracerCarrier'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        ></g>
                        <g id='SVGRepo_iconCarrier'>
                          {' '}
                          <path
                            d='M4 4C4 3.44772 4.44772 3 5 3H14H14.5858C14.851 3 15.1054 3.10536 15.2929 3.29289L19.7071 7.70711C19.8946 7.89464 20 8.149 20 8.41421V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V4Z'
                            stroke='#FFFFFF'
                            strokeWidth='2'
                            strokeLinecap='round'
                          ></path>{' '}
                          <path
                            d='M20 8H15V3'
                            stroke='#FFFFFF'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                          <path
                            d='M11.5 13H11V17H11.5C12.6046 17 13.5 16.1046 13.5 15C13.5 13.8954 12.6046 13 11.5 13Z'
                            stroke='#FFFFFF'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                          <path
                            d='M15.5 17V13L17.5 13'
                            stroke='#FFFFFF'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                          <path
                            d='M16 15H17'
                            stroke='#FFFFFF'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                          <path
                            d='M7 17L7 15.5M7 15.5L7 13L7.75 13C8.44036 13 9 13.5596 9 14.25V14.25C9 14.9404 8.44036 15.5 7.75 15.5H7Z'
                            stroke='#FFFFFF'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                        </g>
                      </svg>
                    </button>
                  </div>
                </Tooltip>
                <Tooltip
                  title='Descargar Factura XML'
                  arrow
                >
                  <div className='bg-primary-inabit-blue hover:bg-primary-inabit-blue-hover rounded-lg h-12 shadow flex justify-center items-center'>
                    <button
                      className='text-center p-4 text-white hover:text-white'
                      onClick={() => {
                        getInvoiceByFormat('xml', data.row);
                      }}
                      disabled={!getChipColor(data.row.internalStatus)}
                    >
                      <svg
                        height='30px'
                        width='30px'
                        version='1.1'
                        id='_x32_'
                        viewBox='0 0 512 512'
                        fill='#FFFFFF'
                      >
                        <g
                          id='SVGRepo_bgCarrier'
                          strokeWidth='0'
                        ></g>
                        <g
                          id='SVGRepo_tracerCarrier'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        ></g>
                        <g id='SVGRepo_iconCarrier'>
                          <g>
                            <path d='M378.406,0H208.29h-13.176l-9.314,9.314L57.013,138.102l-9.314,9.314v13.176v265.514 c0,47.36,38.528,85.895,85.895,85.895h244.812c47.368,0,85.895-38.535,85.895-85.895V85.896C464.301,38.528,425.773,0,378.406,0z M432.49,426.105c0,29.877-24.214,54.091-54.084,54.091H133.594c-29.877,0-54.091-24.214-54.091-54.091V160.591h83.717 c24.884,0,45.07-20.178,45.07-45.07V31.804h170.115c29.87,0,54.084,24.214,54.084,54.092V426.105z'></path>
                            <path d='M178.002,297.743l21.051-30.701c1.361-2.032,2.032-4.07,2.032-6.109c0-5.027-3.938-8.965-9.37-8.965 c-3.394,0-6.11,1.494-8.281,4.754l-16.575,24.452h-0.265l-16.576-24.452c-2.172-3.26-4.888-4.754-8.281-4.754 c-5.432,0-9.37,3.938-9.37,8.965c0,2.039,0.67,4.077,2.031,6.109l20.919,30.701l-22.546,33.138 c-1.355,2.039-2.039,4.077-2.039,6.116c0,5.027,3.938,8.965,9.371,8.965c3.393,0,6.116-1.494,8.288-4.755l18.203-26.896h0.265 l18.203,26.896c2.171,3.261,4.894,4.755,8.287,4.755c5.432,0,9.37-3.938,9.37-8.965c0-2.039-0.677-4.078-2.039-6.116 L178.002,297.743z'></path>
                            <path d='M291.016,251.968c-5.977,0-9.238,3.261-12.226,10.326l-19.284,44.547h-0.545l-19.697-44.547 c-3.121-7.066-6.382-10.326-12.358-10.326c-6.654,0-11.004,4.622-11.004,11.954v72.398c0,6.109,3.806,9.643,9.244,9.643 c5.153,0,8.958-3.534,8.958-9.643v-44.554h0.678l14.397,33.138c2.856,6.522,5.167,8.428,9.782,8.428 c4.615,0,6.927-1.906,9.782-8.428L283,291.766h0.684v44.554c0,6.109,3.666,9.643,9.098,9.643c5.432,0,9.098-3.534,9.098-9.643 v-72.398C301.88,256.59,297.67,251.968,291.016,251.968z'></path>
                            <path d='M373.211,327.355h-32.873c-0.544,0-0.824-0.272-0.824-0.816V262.56c0-6.381-4.203-10.592-9.915-10.592 c-5.837,0-10.04,4.21-10.04,10.592v72.532c0,5.976,3.938,10.054,10.04,10.054h43.611c6.102,0,10.04-3.666,10.04-8.965 C383.251,331.02,379.313,327.355,373.211,327.355z'></path>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </div>
                </Tooltip>
              </div>
            ) : data.row?.pdfUrl ? (
              <div className='grid grid-cols-4 grid-flow-col gap-1 grid-flow-row-dense'>
                <Tooltip
                  title='Descargar comprobante de cancelación PDF'
                  arrow
                >
                  <div className='bg-primary-inabit-red hover:bg-primary-inabit-red-hover rounded-lg h-12 shadow flex justify-center items-center'>
                    <a
                      className='text-center p-4 text-white hover:text-white'
                      href={`data:application/pdf;base64,${data.row.pdfUrl}`}
                      target='_blank'
                      rel='noreferrer'
                      download={`Comprobante-${data.row.Folio}`}
                    >
                      <svg
                        width='30px'
                        height='30px'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        stroke='#FFFFFF'
                      >
                        <g
                          id='SVGRepo_bgCarrier'
                          strokeWidth='0'
                        ></g>
                        <g
                          id='SVGRepo_tracerCarrier'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        ></g>
                        <g id='SVGRepo_iconCarrier'>
                          {' '}
                          <path
                            d='M4 4C4 3.44772 4.44772 3 5 3H14H14.5858C14.851 3 15.1054 3.10536 15.2929 3.29289L19.7071 7.70711C19.8946 7.89464 20 8.149 20 8.41421V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V4Z'
                            stroke='#FFFFFF'
                            strokeWidth='2'
                            strokeLinecap='round'
                          ></path>{' '}
                          <path
                            d='M20 8H15V3'
                            stroke='#FFFFFF'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                          <path
                            d='M11.5 13H11V17H11.5C12.6046 17 13.5 16.1046 13.5 15C13.5 13.8954 12.6046 13 11.5 13Z'
                            stroke='#FFFFFF'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                          <path
                            d='M15.5 17V13L17.5 13'
                            stroke='#FFFFFF'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                          <path
                            d='M16 15H17'
                            stroke='#FFFFFF'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                          <path
                            d='M7 17L7 15.5M7 15.5L7 13L7.75 13C8.44036 13 9 13.5596 9 14.25V14.25C9 14.9404 8.44036 15.5 7.75 15.5H7Z'
                            stroke='#FFFFFF'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></path>{' '}
                        </g>
                      </svg>
                    </a>
                  </div>
                </Tooltip>
              </div>
            ) : data.row?.Status == 'cancellation_requested' ? (
              <div
                className='grid grid-cols-1 grid-flow-col gap-1 grid-flow-row-dense'
                onClick={() => {
                  handlerCancelCheckInvoice(data.row);
                }}
              >
                <div className='px-2 bg-primary-inabit-blue hover:bg-primary-inabit-blue-hover rounded-lg h-12 shadow flex justify-left items-center text-white cursor-pointer'>
                  <p>Consultar cancelación</p>
                </div>
              </div>
            ) : (
              <div className='grid grid-cols-1 grid-flow-col gap-1 grid-flow-row-dense'>
                <div className='bg-primary-inabit-red hover:bg-primary-inabit-red-hover rounded-lg h-12 shadow flex justify-center items-center cursor-not-allowed text-white'>
                  <p>Sin comprobante de cancelación</p>
                </div>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className='w-full overflow-auto'>
      <div className='flex flex-row-reverse'>
        {selectedRows.length > 0 && profile.canGenerateInvoices && (
          <button
            type='button'
            onClick={() => createPayment()}
            className={`inline-flex float-right items-center px-4 py-2 mx-2 font-semibold leading-6 text-sm shadow rounded-lg text-white bg-primary-inabit-blue hover:bg-primary-inabit-blue-hover transition ease-in-out duration-150 mb-4`}
          >
            Generar Complemento de Pago
          </button>
        )}

        <button
          type='button'
          onClick={() => createInvoice({})}
          className='inline-flex float-right items-center px-4 py-2 font-semibold leading-6 text-sm shadow rounded-lg text-white bg-primary-inabit-blue hover:bg-primary-inabit-blue-hover transition ease-in-out duration-150 mb-4'
        >
          Generar Factura
        </button>
      </div>
      {/* Invoice Modal */}
      <Modal
        onClose={() => setIsOpenModalInvoice(false)}
        isOpen={isOpenModalInvoice}
      >
        <Facturama />
      </Modal>

      {/* Complement Modal */}
      <Modal
        onClose={() => setIsOpenModalComplement(false)}
        isOpen={isOpenModalComplement}
      >
        <Payment selectedInvoices={selectedRows} />
      </Modal>

      <DataGrid
        autoHeight
        localeText={{
          toolbarDensity: 'Tamaño de Columnas',
          toolbarDensityLabel: 'Size',
          toolbarDensityCompact: 'Pequeño',
          toolbarDensityStandard: 'Medio',
          toolbarDensityComfortable: 'Grande',
          toolbarExport: 'Exportar',
          toolbarFilters: 'Filtros',
          toolbarColumns: 'Columnas',
        }}
        rows={list || []}
        columns={columns}
        pageSize={12}
        loading={controls.loading}
        className='rounded-xl'
        components={{ Toolbar: CustomToolbar }}
        density='comfortable'
        checkboxSelection={profile.canGenerateInvoices}
        selectionModel={selectionModel}
        isRowSelectable={params => {
          const isPaymentFormValid =
            params.row.PaymentForm === "99" ||
            !params.row.PaymentForm ||
            params.row.PaymentForm?.startsWith('99') ||
            params.row.PaymentTerms?.startsWith('99');

          const isPaymentMethodValid =
            params.row.PaymentMethod === 'PPD' ||
            params.row.PaymentMethod?.startsWith('PPD');

          const isBaseValid =
            isPaymentFormValid &&
            isPaymentMethodValid &&
            params.row.Status === 'active' &&
            !params.row.payment &&
            (params.row.Receiver?.Rfc !== 'XAXX010101000' || true);

          if (!isBaseValid) return false;

          if (selectedRows.length === 0) return true;

          const activeProvider = selectedRows[0]?.provider === 'listo' ? 'listo' : 'facturama';
          const rowProvider = params.row.provider === 'listo' ? 'listo' : 'facturama';

          return rowProvider === activeProvider;
        }}
        onSelectionModelChange={ids => {
          const selectedIDs = new Set(ids);
          const selectedRows = list?.filter(row =>
            selectedIDs.has(row.id ?? ''),
          );
          setSelectedRows(
            selectedRows || [],
          );
          setSelectionModel(ids as GridSelectionModel);
        }}
      />
    </div>
  );
};

const withConnect = connect(
  selectState(
    'app.profile',
    'invoicesList.controls',
    'invoicesList.list',
    'invoicesList.report',
    'invoice.invoiceControls',
    'payment.paymentControls',
  ),
  actionProps({
    ...invoicesActions,
    ...invoiceActions,
  }),
);

export default withRouter(withConnect(Invoices));
